import React, { ReactNode } from 'react';
import { Box } from '@mui/material';

export const ScrollContainer = ({
  children,
  bottom,
}: {
  children: ReactNode;
  bottom: ReactNode;
}) => (
  <Box display="flex" flexDirection="column" height="calc(100vh - 136px)">
    <Box
      flexGrow={1}
      flexShrink={1}
      style={{
        overflowY: 'auto',
      }}
    >
      {children}
    </Box>
    {bottom}
  </Box>
);
